export interface EssentialTool {
  id: string
  title: string
  subtitle: string
  paragraphs: string[]
  closing: string
}

export const essentialTools: EssentialTool[] = [
  {
    id: 'Essential Tool 1',
    title: 'Golf Coaching Cues & Common Fault Solutions',
    subtitle: 'Clear Teaching Language, Effective Corrections and Practical Solutions for Common Golf Mistakes',
    paragraphs: [
      'A complete guide to identifying frequent technical errors and correcting them using clear, simple and effective coaching language. Covers grip, posture, alignment, balance, takeaway, backswing, transition, impact, follow-through, putting, chipping, pitching and longer shots. For each area, you receive practical cues you can use during a lesson without overwhelming your student with unnecessary technical detail.',
      'The guide also helps you understand the possible causes behind each mistake and choose the right correction, drill or progression. Especially useful when a student feels stuck, repeats the same error, or struggles to understand traditional technical explanations.',
    ],
    closing: 'No preparation needed. Open it, read it, teach it.',
  },
  {
    id: 'Essential Tool 2',
    title: '100 Golf Drills, Practice Games & Skill Challenges',
    subtitle: 'A Complete Activity Bank for More Dynamic, Varied and Engaging Golf Lessons',
    paragraphs: [
      '100 practical drills, games and challenges that make golf lessons more engaging, structured and goal-oriented. Covers putting, distance control, chipping, pitching, bunker play, irons, woods, driver accuracy, ball striking, consistency and course strategy. Can be used in private lessons, small groups, junior programs, adult clinics and academy sessions.',
      'Each activity targets a specific skill while keeping students active and motivated. Use them as the main part of a session, as a progress challenge, as a review activity or as a competitive game between students.',
    ],
    closing: '100 fresh ideas ready to use. The variety is already built in.',
  },
]
